import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatMoney, url } from "@/utils";
import { DataGrid } from "@mui/x-data-grid";
import { Stack } from "@mui/material";
import OptionsMenu from "@/components/core/TableOptionMenu";
import { OrderData } from "@/data/dtos/order.dto";
import { getAll, remove } from "@/actions/invoice.action";
import { InvoiceDto } from "@/data/dtos/invoice.dto";

export default function InvoiceList() {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { invoices, status } = useSelector((state: any) => state.invoices);

  const handleDelete = async (id) => {
    dispatch(remove(id) as any);
  };

  useEffect(() => {
    console.log("useEffect 1");
    if (status === "idle" && invoices?.length === 0) {
      dispatch(getAll() as any);
    }
  }, [dispatch, status, invoices]);

  const pageSizeOptions = [25, 50, 100];

  const columns = [
    {
      field: "totalprice",
      headerName: "Tahsil Edilen Toplam Tutar",
      flex: 0.3,
      valueGetter: (param: any) => formatMoney(param),
    },
    {
      field: "invoiceNo",
      headerName: "Müşteri Fatura No",
      flex: 0.3,
    },
    {
      field: "paymentChannel",
      headerName: "Ödeme Kanalı",
      flex: 0.2,
    },
    {
      field: "installmentCount",
      headerName: "Ödeme Şekli",
      flex: 0.1,
    },
    {
      field: "paymentStatus",
      headerName: "Ödeme Durumu",
      flex: 0.1,
    },
    {
      field: "options",
      headerName: "Seçenekler",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation(); // Prevent row selection on click
          // You can manage the menu state in the parent or directly in the component
        };

        return (
          <Stack direction="row" spacing={1}>
            <OptionsMenu
              id={params.row._id}
              onEdit={() => {
                navigation(url("Admin.Orders.Edit", { id: params.row._id }));
              }}
              onDelete={handleDelete}
              onOpenMenu={handleMenuOpen} // Pass the handler to OptionsMenu
            />
          </Stack>
        );
      },
    },
  ];
  if (invoices?.length > 0) {
    const rows = invoices?.map((invoice: InvoiceDto, index) => {
      return {
        _id: invoice._id,
        no: index + 1,
        totalprice: (invoice.order as OrderData).paidPrice,
        invoiceNo: invoice.invoiceNumber,
        paymentChannel: invoice.paymentType,
        installmentCount: invoice.installmentCount,
        paymentStatus: invoice.paymentStatus,
      };
    });

    return (
      <div className="w-full bg-white">
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={pageSizeOptions}
          checkboxSelection
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
            },
          }}
          getRowId={(row) => row._id} // Benzersiz ID için _id kullan
        />
      </div>
    );
  } else {
    return <div>Fatura Yok</div>;
  }
}
